export default import.meta.ROLLDOWN_FILE_URL_aLISaAY6NSiJFT$6GdtrfA